import {
  getSelectedDistrict,
  getSelectedSport,
  selectSeeAllScoresButton,
} from 'app/imports/App.selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useScoresLink } from '../../hooks/useScoresLink'
import * as Styled from './StandingsButton.styled'

export function StandingsButton() {
  const seeAllScoresButton = useSelector(selectSeeAllScoresButton)
  const district = useSelector(getSelectedDistrict)
  const selectedSport = useSelector(getSelectedSport)

  const title = useMemo(() => {
    if (!district) return ''

    let result = district.name
    if (selectedSport) {
      result += ` ${selectedSport.name}`
    }

    return `${result} Hub`
  }, [district, selectedSport])

  const { scoresUrl } = useScoresLink(selectedSport?.id)

  if (!seeAllScoresButton) {
    return null
  }

  return (
    <Styled.ButtonContainer href={scoresUrl} target="_blank">
      <Styled.Button type="button">{title}</Styled.Button>
    </Styled.ButtonContainer>
  )
}
